import React, { memo } from 'react'
import { oneOf, string } from 'prop-types'
import SVG from './SVG'

export const ArrowNavigation = memo(({ direction, fill, height = '17px', width = '25px' }) => (
	<SVG
		fill={fill}
		width={width}
		height={height}
		viewBox="10 0 5 25"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		style={{ transform: `rotate(${direction === 'previous' ? 45 : 225}deg)` }}
	>
		<g>
			<path
				d="M8,4 L8,16.999 L21,17 L21,21 L4,21 L4,4 L8,4 Z"
				transform={`translate(12.5, 12.5)  translate(-12.5, -12.5)`}
			></path>
		</g>
	</SVG>
))

ArrowNavigation.propTypes = {
	direction: oneOf(['previous', 'next']),
	fill: string,
	height: string,
	width: string,
}
